import React from 'react';
import { CreditCardFeeDisclaimer } from 'components';
import { Modal } from 'components/modal/Modal';
import { Button, Container, Flex, Text, Link, List } from 'basis';
import { OverviewSources } from '_config';
import { getRatesAndFees } from 'featureToggles';
import { getTerms } from 'utils';

export const AuGemFeaturesAndBenefits = ({ isOpen, onClose, getLinkWithAnalytics, trackEventSender }) => {
  const { purchaseAnnualRate, cashAnnualRate, expiredPromotionalPurchaseRate, monthlyFee } = getRatesAndFees();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Container padding="6" padding-md="8">
        <Container padding="0 0 4">
          <Flex placeItems="left center">
            <Text textStyle="heading6" textStyle-md="heading5">
              Credit card features and benefits
            </Text>
          </Flex>
        </Container>
        <Container>
          <Text textStyle="body1">
            Please ensure the{' '}
            <Link
              href={getLinkWithAnalytics(OverviewSources.AU.latitude_gem_visa)}
              newTab
              onClick={() => trackEventSender(OverviewSources.AU.latitude_gem_visa)}
            >
              {OverviewSources.AU.latitude_gem_visa.label}
            </Link>{' '}
            credit card is right for you.
          </Text>
        </Container>
        <Container padding="6 0" margin="4 0 0 0">
          <List>
            <List.Item>
              <Text textStyle="body1">
                Earn 3% back in Latitude Rewards on eligible spend across groceries, dining, food delivery, movies and
                theatre purchases — after you spend $1,000 or more on general purchases in a statement period.{' '}
                <Link
                  newTab
                  href={getLinkWithAnalytics({
                    label: 'Terms and Conditions',

                    url: OverviewSources.AU.gem_visa_terms_and_condition.url,
                  })}
                  onClick={() =>
                    trackEventSender({
                      location: 'landing',
                      label: 'Terms and Conditions',
                    })
                  }
                >
                  T&Cs apply
                </Link>
                .
              </Text>
            </List.Item>
            <List.Item>
              <Text textStyle="body1">
                Enjoy 0% interest for 6 months on {getTerms('generalPurchases')} of $250 or more. Select your purchases
                in the Latitude App or Latitude Service Centre within 30 days of purchase.{' '}
                <Link
                  newTab
                  href={getLinkWithAnalytics({
                    label: 'Rates and Fees',
                    url: OverviewSources.AU.gem_visa_interest_free.url,
                  })}
                  onClick={() =>
                    trackEventSender({
                      location: 'landing',
                      label: 'Rates and Fees',
                    })
                  }
                >
                  Find more details
                </Link>
                .
              </Text>
            </List.Item>
            <List.Item>
              <Text textStyle="body1">
                Up to 55 days interest free on all other {getTerms('generalPurchases')}.<sup>1</sup>
              </Text>
            </List.Item>
            <List.Item>
              <Text textStyle="body1">
                Interest free offers available from 6 to 60 months at thousands of Australia's leading retailers.
              </Text>
            </List.Item>
            <List.Item>
              <Text textStyle="body1">
                Get exclusive deals, discounts and offers by simply using your Latitude Gem Visa credit card at home and{' '}
                overseas.
              </Text>
            </List.Item>
            <List.Item>
              <Text textStyle="body1">
                Interest Rates - {purchaseAnnualRate?.toFixed(2)}% p.a. interest rate on {getTerms('generalPurchases')},{' '}
                {cashAnnualRate?.toFixed(2)}% p.a. on cash advances and {expiredPromotionalPurchaseRate?.toFixed(2)}%{' '}
                p.a on expired Interest Free Payment Plans
              </Text>
            </List.Item>
            <List.Item>
              Account Fee - ${monthlyFee.toFixed(2)} {getTerms('monthlyCreditCardFee')} (see other{' '}
              <Link
                newTab
                href={getLinkWithAnalytics({
                  label: 'Rates and Fees',
                  url: OverviewSources.AU.latitude_gem_visa.url,
                })}
                onClick={() =>
                  trackEventSender({
                    location: 'landing',
                    label: 'Rates and Fees',
                  })
                }
              >
                Rates and Fees
              </Link>{' '}
              here)
              <CreditCardFeeDisclaimer />
            </List.Item>
            <List.Item>
              <Text textStyle="body1">
                Safe and secure - Shop knowing that your card and account are protected by stringent security systems.
              </Text>
            </List.Item>
            <List.Item>
              Before making a decision, please read the{' '}
              <Link
                newTab
                href={getLinkWithAnalytics(OverviewSources.AU.key_facts_sheet)}
                onClick={() =>
                  trackEventSender({
                    location: 'landing',
                    label: OverviewSources.AU.key_facts_sheet.label,
                  })
                }
              >
                {OverviewSources.AU.key_facts_sheet.label}
              </Link>{' '}
              and{' '}
              <Link
                newTab
                href={OverviewSources.AU.gem_conditions_of_use.url}
                onClick={() =>
                  trackEventSender({
                    location: 'landing',
                    label: OverviewSources.AU.gem_conditions_of_use.label,
                  })
                }
              >
                {OverviewSources.AU.gem_conditions_of_use.label}
              </Link>{' '}
              to ensure you're aware of all the fees, charges and interest rates.
            </List.Item>
          </List>
        </Container>
        <Container padding="4 0">
          <Text>
            <sup>1</sup>To take advantage of up to 55 days interest free on {getTerms('creditCardGeneralPurchases')},
            you need to pay the full closing balance (excluding un-expiring interest payment plans) on each statement of
            account by the applicable due date.
          </Text>
        </Container>

        <Flex placeItems="center">
          <Container padding="2">
            <Button width="160px" onClick={onClose}>
              Close
            </Button>
          </Container>
        </Flex>
      </Container>
    </Modal>
  );
};
